import { Component, OnInit, Inject, ViewChild, OnChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';



@Component({
  selector: 'app-select-item-dialog',
  templateUrl: './select-item-dialog.component.html',
  styleUrls: ['./select-item-dialog.component.scss']
})
export class SelectItemDialogComponent implements OnInit {

  displayedColumns: string[] = ['select', 'codigo', 'nombre'];
  dataSource: MatTableDataSource<any>;
  SelectItem: any;
  selection = new SelectionModel<any>(true, []);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SelectItemDialogComponent>) {

    this.dataSource = new MatTableDataSource(data.data);

   }

  ngOnInit() {
    const ItemsSelected = this.data.select as any[];
    if ( ItemsSelected) {
      ItemsSelected.forEach(element => {
        this.selection.toggle(element);
      });
    }

  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  close() {
    this.dialogRef.close(null);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

 sendSelect() {
  const data = {  item: this.selection.selected };
  this.dialogRef.close(data);
 }

}
